import {
  ComponentFactoryResolver,
  HostListener,
  inject,
  Inject,
  Injectable,
  Renderer2,
  ViewContainerRef,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AgroData, AppConst, CommonStoreData, RakutenData } from "src/app/app.constants";
import * as CryptoJS from "crypto-js";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { environmentProd } from "src/environments/environment.prod";
import { CommonIconComponent } from "src/app/shared/lib/common-icon/common-icon.component";
import moment from 'moment';;
import { Router } from "@angular/router";
import { ToastService } from "../toastService/toast-service";
declare const AdobeDC: any;

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  private http = inject(HttpClient);
  static getWorkAreaAndStoreId() {
    throw new Error("Method not implemented.");
  }
  headers: {};
  _key = CryptoJS.enc.Base64.parse(AppConst.KEY_BASE_64);
  width: number;
  isMobileLayout: boolean = false;
  screenHeight: number;
  bucket: any;
  imageURL: any;
  storeId: any;
  countryName: any;
  serverTime: Date;
  setServer: BehaviorSubject<Date>;
  getServer: Observable<Date>;

  // public externalObjSubject = new BehaviorSubject<any>(null);
  // externalObj = this.externalObjSubject.asObservable();
  public rakutenData: RakutenData;
  public agroData: AgroData;
  public commonStoreData: CommonStoreData

  // s3Image = new S3({
  //   region: AppConst.DEFAULT_AWS_KEY.awsregionImage,
  //   accessKeyId: AppConst.DEFAULT_AWS_KEY.awsaccessKeyIdImage,
  //   secretAccessKey: AppConst.DEFAULT_AWS_KEY.awssecretAccessKeyImage,
  // });

  // s3Pdf = new S3({
  //   region: AppConst.DEFAULT_AWS_KEY.awsregionPdf,
  //   accessKeyId: AppConst.DEFAULT_AWS_KEY.awsaccessKeyIdPdf,
  //   secretAccessKey: AppConst.DEFAULT_AWS_KEY.awssecretAccessKeyPdf,
  // });
  constructor(
    @Inject(ComponentFactoryResolver)
    private factoryResolver: ComponentFactoryResolver,
    private router: Router,
    private toastService: ToastService,
  ) {
    this.setServer = new BehaviorSubject(this.serverTime);
    this.getServer = this.setServer.asObservable();
  }
  /* More Than two or more true in a boolean array checker */
  multicheck(arr: Array<any>) {
    return arr.filter(Boolean).length >= 2;
  }
  /* Get environment Url. true: prod, false: development */
  getProdOrDevUrl() {
    const environment = AppConst.ENV_VARIABLE === "development" ? false : true;
    return environment;
  }
  /* Get environment Url. true: prod, false: development */

  SHA256(s: string | any[]) {
    let chrsz = 8;
    let hexcase = 0;

    function safe_add(x: any, y: any) {
      let lsw = (x & 0xffff) + (y & 0xffff);
      let msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return (msw << 16) | (lsw & 0xffff);
    }

    function S(X: any, n: any) {
      return (X >>> n) | (X << (32 - n));
    }
    function R(X: any, n: any) {
      return X >>> n;
    }
    function Ch(x: any, y: any, z: any) {
      return (x & y) ^ (~x & z);
    }
    function Maj(x: any, y: any, z: any) {
      return (x & y) ^ (x & z) ^ (y & z);
    }
    function Sigma0256(x: any) {
      return S(x, 2) ^ S(x, 13) ^ S(x, 22);
    }
    function Sigma1256(x: any) {
      return S(x, 6) ^ S(x, 11) ^ S(x, 25);
    }
    function Gamma0256(x: any) {
      return S(x, 7) ^ S(x, 18) ^ R(x, 3);
    }
    function Gamma1256(x: any) {
      return S(x, 17) ^ S(x, 19) ^ R(x, 10);
    }

    function core_sha256(m: any, l: any) {
      let K = new Array(
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0xfc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x6ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2,
      );
      let HASH = new Array(
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19,
      );
      let W = new Array(64);
      let a, b, c, d, e, f, g, h, i, j;
      let T1, T2;

      m[l >> 5] |= 0x80 << (24 - (l % 32));
      m[(((l + 64) >> 9) << 4) + 15] = l;

      for (let i = 0; i < m.length; i += 16) {
        a = HASH[0];
        b = HASH[1];
        c = HASH[2];
        d = HASH[3];
        e = HASH[4];
        f = HASH[5];
        g = HASH[6];
        h = HASH[7];

        for (let j = 0; j < 64; j++) {
          if (j < 16) W[j] = m[j + i];
          else
            W[j] = safe_add(
              safe_add(
                safe_add(Gamma1256(W[j - 2]), W[j - 7]),
                Gamma0256(W[j - 15]),
              ),
              W[j - 16],
            );

          T1 = safe_add(
            safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]),
            W[j],
          );
          T2 = safe_add(Sigma0256(a), Maj(a, b, c));

          h = g;
          g = f;
          f = e;
          e = safe_add(d, T1);
          d = c;
          c = b;
          b = a;
          a = safe_add(T1, T2);
        }
        HASH[0] = safe_add(a, HASH[0]);
        HASH[1] = safe_add(b, HASH[1]);
        HASH[2] = safe_add(c, HASH[2]);
        HASH[3] = safe_add(d, HASH[3]);
        HASH[4] = safe_add(e, HASH[4]);
        HASH[5] = safe_add(f, HASH[5]);
        HASH[6] = safe_add(g, HASH[6]);
        HASH[7] = safe_add(h, HASH[7]);
      }
      return HASH;
    }

    function str2binb(str: any) {
      let bin = Array();
      let mask = (1 << chrsz) - 1;
      for (let i = 0; i < str.length * chrsz; i += chrsz) {
        bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - (i % 32));
      }
      return bin;
    }

    function Utf8Encode(string: any) {
      string = string.replace(/\r\n/g, "\n");
      let utftext = "";

      for (let n = 0; n < string.length; n++) {
        let c = string.charCodeAt(n);

        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }

      return utftext;
    }

    function binb2hex(binarray: any) {
      let hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
      let str = "";
      for (let i = 0; i < binarray.length * 4; i++) {
        str +=
          hex_tab.charAt((binarray[i >> 2] >> ((3 - (i % 4)) * 8 + 4)) & 0xf) +
          hex_tab.charAt((binarray[i >> 2] >> ((3 - (i % 4)) * 8)) & 0xf);
      }
      return str;
    }

    s = Utf8Encode(s);
    return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
  }

  getHeader(params: any, apiVersion: number) {
    if (params === "") {
      this.headers = new HttpHeaders({
        apiversion: "1",
      });
    } else {
      const _srcs = CryptoJS.enc.Utf8.parse(params);
      const _encryptedText = CryptoJS.AES.encrypt(_srcs, this._key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      this.headers = new HttpHeaders({
        apiversion: apiVersion.toString(),
        encVal: _encryptedText,
      });
      const addHeaders = {
        sessionToken: localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData") || "")["sessionId"]
          : "",
        userId: localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData") || "")["userId"]
          : "",
        accessToken: localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData") || "")["accessToken"]
          : "",
      };
      const session: string = localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData") || "")
        : "";
      let headParams = {
        apiversion: apiVersion.toString(),
        encVal: _encryptedText,
      };
      if (session) {
        headParams = {
          ...headParams,
          ...addHeaders,
        };
      }
      this.headers = new HttpHeaders({
        ...headParams,
      });
    }
    return { headers: this.headers };
  }
  getEncData(value: string) {
    const _srcs = CryptoJS.enc.Utf8.parse(value);
    const _encryptedText = CryptoJS.AES.encrypt(_srcs, this._key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    return _encryptedText;
  }

  getEncryptedVal(value: string) {
    const userData = JSON.parse(this.get());
    const _key = CryptoJS.enc.Base64.parse(userData.sessionId);
    const _srcs = CryptoJS.enc.Utf8.parse(value);
    const _encryptedText = CryptoJS.AES.encrypt(_srcs, _key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    return _encryptedText;
  }

  getSpecialHeader(params: any, apiVersion: number) {
    if (params === "") {
      this.headers = new HttpHeaders({
        apiversion: "1",
      });
    } else {
      const _srcs = CryptoJS.enc.Utf8.parse("raceprojectv2");
      const _encryptedText = CryptoJS.AES.encrypt(_srcs, this._key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      this.headers = new HttpHeaders({
        apiversion: apiVersion.toString(),
        encVal: _encryptedText,
      });
      const addHeaders = {
        sessionToken: localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData") || "")["sessionId"]
          : "",
        userId: localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData") || "")["userId"]
          : "",
        accessToken: localStorage.getItem("userData")
          ? JSON.parse(localStorage.getItem("userData") || "")["accessToken"]
          : "",
      };
      const session: string = localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData") || "")
        : "";
      let headParams = {
        apiversion: apiVersion.toString(),
        encVal: _encryptedText,
      };
      if (session) {
        headParams = {
          ...headParams,
          ...addHeaders,
        };
      }
      this.headers = new HttpHeaders({
        ...headParams,
      });
    }
    return { headers: this.headers };
  }

  preReqScript(params: any) {
    const formVal = params;
    const encodedJSON = encodeURIComponent(formVal);
  }

  get(): any {
    return localStorage.getItem("userData");
  }

  extractStorageData() {
    return new Promise((resolve: any, reject: any) => {
      const userData: any = localStorage.getItem("userData");
      const parserData = JSON.parse(userData);
      userData !== null ? resolve(parserData) : reject(false);
    });
  }

  getTokenValue() {
    return new Promise((resolve: any, reject: any) => {
      this.extractStorageData().then((data: any) => {
        !data ? reject() : resolve(data.accessToken);
      });
    });
  }

  getMenuList() {
    return new Promise((resolve: any, reject: any) => {
      this.extractStorageData().then((data: any) => {
        !data ? reject() : resolve(data.menu);
      });
    });
  }

  stringToLowerAndReplceSpaceToDash(toBeReplaced: string) {
    const strName = toBeReplaced.replace(/\s+/g, "-").toLowerCase();
    return strName;
  }

  setMobileLayout() {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (width <= 991) {
      this.isMobileLayout = true;
    } else {
      this.isMobileLayout = false;
    }
    return this.isMobileLayout; //width <= 991;
  }

  getOnlyNumber() {
    const onlyNumberRegEx = /^[0-9]+$/;
    return onlyNumberRegEx;
  }

  getADCredRegEx() {
    const alphabetRegEx = /^[A-Za-z0-9.]+$/;
    return alphabetRegEx;
  }

  getCurrencyRegEx() {
    const currRegEx =
      /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
    return currRegEx;
  }

  replaceFrwSlash(toBeReplaced: string) {
    const strName = toBeReplaced.replace(/\//g, "~*~");
    return strName;
  }

  replaceBackSlash(toBeReplaced: string) {
    const strName = toBeReplaced.replace(/\n/g, "~4~");
    return strName;
  }

  forwardReplaceBackSlash(toBeReplaced: string) {
    const strName = toBeReplaced.replace(/~4~/g, "\n");
    // console.log(strName);
    return strName;
  }

  replacePercentage(toBeReplaced: string) {
    const strName = toBeReplaced.replace(/\%/g, "~5~");
    return strName;
  }

  postFixemailDomain(adString: string) {
    return adString + AppConst.DEFAULT_POST_FIX_USERNAME;
  }

  charSubsting(data: string, lengthToSubString: number) {
    return data.substring(0, lengthToSubString) + "...";
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenHeight = this.getScreenHeight();
  }

  getScreenHeight() {
    return window.innerHeight;
  }

  viewPdf(fileName: string, filePath: string, divId: string) {
    const env = this.getProdOrDevUrl();
    const adobeDCView = new AdobeDC.View({
      clientId: env ? environmentProd.key.pdfViewer : environment.key.pdfViewer,
      divId,
    });

    adobeDCView.previewFile(
      {
        content: { location: { url: filePath } },
        metaData: { fileName: fileName, hasReadOnlyAccess: true },
      },
      {
        enableLinearization: true,
      },
    );
  }

  getProductSearchRegEx() {
    const alphabetRegEx = /^[A-Za-z0-9-, ]+$/;
    return alphabetRegEx;
  }

  getDataForMapPoint(list: any) {
    const baseCoOrdinate = JSON.parse(list.baseLocCoOrd);
    const dataArr = [
      {
        name: list.baseLocation,
        lat: parseFloat(baseCoOrdinate[1]),
        lon: parseFloat(baseCoOrdinate[0]),
        color: "green",
      },
    ];

    const geoDataArr = [];

    list.data.map((geoList: any, index: number) => {
      geoList.bidderDetails.map((bidderList: any, bidderIndex: number) => {
        dataArr.push({
          name: bidderList.cityName,
          lat: parseFloat(JSON.parse(bidderList.geoLoc[1])),
          lon: parseFloat(JSON.parse(bidderList.geoLoc[0])),
          color: bidderList.distance > 0 ? "red" : "green",
        });
        geoDataArr.push({
          geometry: {
            type: "LineString",
            coordinates: [baseCoOrdinate, bidderList.geoLoc],
          },
          name: list.baseLocation + " -> " + bidderList.cityName,
          color: "black",
        });
      });
    });

    /* //console.log('dataArr List : ', dataArr);
    //console.log('geoDataArr List : ', geoDataArr); */
    const retunData = {
      dataList: dataArr,
      geoData: geoDataArr,
    };
    /* //console.log('dataArr : ', dataArr); */
    return retunData;
  }

  getDataForNetworkGraph(list: any) {
    const baseLocation = "Client Location : " + list.baseLocation;
    const newArr = [["undefined", baseLocation, baseLocation]];
    let distanceCountArr = 1;

    list.data.map((geoList: any, index: number) => {
      distanceCountArr++;
      geoList.bidderDetails.map((bidderList: any, bidderIndex: number) => {
        distanceCountArr++;
      });
    });

    list.data.map((geoList: any, index: number) => {
      /* const count = ' Km (' + geoList.bidderDetails.length + ')'; */
      const count = " Km";
      if (index === list.data.length - 1) {
        geoList._id = ">= " + geoList._id + count;
      } else {
        geoList._id =
          geoList._id + "-" + (Number(list.data[index + 1]._id) - 1) + count;
      }
      const getDistance = geoList._id;
      const dataToPush = [baseLocation, getDistance, getDistance];
      newArr.push(dataToPush);
    });

    list.data.map((geoList: any, index: number) => {
      const distance = geoList._id;
      geoList.bidderDetails.map((bidderList: any, bidderIndex: number) => {
        const endPointData = [
          distance,
          bidderList.cityName + "(" + bidderList.count + ")",
          bidderList.cityName + "(" + bidderList.count + ")",
        ];
        newArr.push(endPointData);
        /* //console.log('endPointData : ', endPointData); */
      });
    });

    const returnArr = {
      chartArr: newArr,
    };
    /* //console.log('newArr : ', newArr); */
    return JSON.stringify(returnArr);
  }

  getHeatMapData(responseData: any) {
    const weekDayName = responseData.weekName;
    const employeeName = [];
    responseData.data.map((list: any) => {
      employeeName.push(list.employee);
    });

    const employeeData = [];
    // Populate the array with initial values
    for (let i = 0; i < employeeName.length; i++) {
      for (let j = 0; j < weekDayName.length; j++) {
        // For simplicity, let's use random values as an example
        const newArr = [i, j, responseData.data[i].data[j]];
        employeeData.push(newArr);
      }
    }
    /* //console.log('employeeData : ', employeeData); */
    return { employeeName, employeeData };
  }

  getBaseUrl(params: any, apiVersion: number) {
    const isProd = this.getProdOrDevUrl();
    const urlTobe = isProd
      ? environmentProd.api_base_url
      : environment.api_base_url;
    const _srcs = CryptoJS.enc.Utf8.parse(params);
    const _encryptedText = CryptoJS.AES.encrypt(_srcs, this._key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    this.headers = new HttpHeaders({
      apiversion: apiVersion.toString(),
      encVal: _encryptedText,
    });
    const addHeaders = {
      sessionToken: localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData") || "")["sessionId"]
        : "",
      userId: localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData") || "")["userId"]
        : "",
      accessToken: localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData") || "")["accessToken"]
        : "",
    };
    const session: string = localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData") || "")
      : "";
    let headParams = {
      apiversion: apiVersion.toString(),
      encVal: _encryptedText,
      accessToken: JSON.parse(localStorage.getItem("userData") || "")[
        "accessToken"
      ],
      sessionId: JSON.parse(localStorage.getItem("userData") || "")[
        "sessionId"
      ],
      userId: JSON.parse(localStorage.getItem("userData") || "")["userId"],
    };
    if (session) {
      headParams = {
        ...headParams,
        ...addHeaders,
      };
    }
    return { urlTobe, headParams };
  }

  getReportFile(filepath: string, fileType: string) {
    const isProd = this.getProdOrDevUrl();
    const urlTobe = isProd
      ? environmentProd.report_base_url
      : environment.report_base_url;

    const fullPath = urlTobe + filepath + "." + fileType;
    return fullPath;
  }

  // getAwsKeys() {
  //   const env = this.getProdOrDevUrl();
  //   const awsKeys = {
  //     secretKey: env
  //       ? environmentProd.key.DEFAULT_SECRET_KEY_ID
  //       : environment.key.DEFAULT_SECRET_KEY_ID,
  //     accessKey: env
  //       ? environmentProd.key.DEFAULT_ACCESS_KEY_ID
  //       : environment.key.DEFAULT_ACCESS_KEY_ID,
  //   };
  //   return awsKeys;
  // }

  async getSignedURL(type, key) {
    // this.store.dispatch(new setShowLoader(true));
    // if (type == 'Image') {
    //   this.bucket = AppConst.DEFAULT_AWS_KEY.bucketImage;
    //   return new Promise((resolve, reject) => {
    //     let params = { Bucket: this.bucket, Key: key };
    //     this.s3Image.getSignedUrl('getObject', params, (err, url) => {
    //       if (err) {
    //         reject(err);
    //       } else {
    //         resolve(url);
    //       }
    //     });
    //   });
    // } else {
    //   this.bucket = AppConst.DEFAULT_AWS_KEY.bucketPdf;
    //   return new Promise((resolve, reject) => {
    //     let params = { Bucket: this.bucket, Key: key };
    //     this.s3Pdf.getSignedUrl('getObject', params, (err, url) => {
    //       if (err) {
    //         reject(err);
    //       } else {
    //         resolve(url);
    //       }
    //     });
    //   });
    // }
  }

  createErrorSubTable() {
    const parentDiv = document.createElement("div");
    const table = document.createElement("table");
    table.setAttribute(
      "class",
      "table table-hover status-table padding subtable w-100",
    );
    const tbody = document.createElement("tbody");
    let tr = document.createElement("tr");
    const td = document.createElement("td");
    td.setAttribute("class", "d-flex justify-content-center");
    td.colSpan = 11;
    tr.appendChild(td);
    tbody.appendChild(tr);
    table.appendChild(tbody);
    parentDiv.appendChild(table);
    return parentDiv;
  }

  createSubTable(
    tableArr: Array<any>,
    trRef: any,
    rowData: any,
    subTable: Array<any>,
    isPagination: boolean,
    icon: any,
    keyNames: Array<any>,
    subTableStatusWithClass: Array<any>,
  ) {
    const parentDiv = document.createElement("div");
    const table = document.createElement("table");
    table.setAttribute(
      "class",
      "table table-hover status-table padding subtable w-100",
    );
    const thead = document.createElement("thead");
    const tbody = document.createElement("tbody");
    thead.setAttribute("class", "table-dark-gray");
    let tr = document.createElement("tr");
    tableArr.map((list: any) => {
      const th = document.createElement("th");
      th.setAttribute("class", "text-center1");
      const text = document.createTextNode(list);
      th.appendChild(text);
      tr.appendChild(th);
    });

    thead.appendChild(tr);
    table.appendChild(thead);
    table.appendChild(tbody);
    parentDiv.appendChild(table);

    isPagination ? this.getSubtableSection(parentDiv, trRef, rowData) : null;
    this.generateSubTable(tbody, subTable, icon, keyNames);
    return parentDiv;
  }

  getSubtableSection(parentDiv, trRef, rowData) {
    const div = document.createElement("div");
    const lowerDiv = document.createElement("div");
    lowerDiv.setAttribute(
      "class",
      "d-flex justify-content-between align-items-center p-2",
    );
    div.setAttribute("class", "custom-page-number");
    const status = document.createElement("p");
    status.setAttribute(
      "class",
      "fw-semibold mb-0 font-small d-none d-sm-block",
    );
    /* const factory = this.factoryResolver.resolveComponentFactory(CommonPaginationComponent); //action data
    const pagination = this.viewContainerRef.createComponent(factory); //pagination
    pagination.instance.page = this.subtableSelectedPageNumber;
    pagination.instance.totalCount = this.subtableTotalRecords;
    pagination.instance.pageSize = this.subTablepageSize;
    pagination.instance.btnClick.subscribe((event) => {
      this.isSubtablePagination = true;
      this.subTablepageCount = event;
      this.expandRow(trRef, rowData);
      //console.log(rowData);
    }); */

    /* status.appendChild(statusmsg);
    div.appendChild(pagination.location.nativeElement); */
    lowerDiv.appendChild(status);
    lowerDiv.appendChild(div);
    parentDiv.appendChild(lowerDiv);
  }

  generateSubTable(
    tbody: any,
    subTable: Array<any>,
    icon: any,
    keyNames: Array<any>,
  ) {
    const factory =
      this.factoryResolver.resolveComponentFactory(CommonIconComponent);
    if (subTable.length > 0) {
      for (let i = 0; i < subTable.length; i++) {
        const list: any = subTable[i];
        const propertyNames = Object.keys(list);
        const tr1 = document.createElement("tr");
        let td1, div, tdText1;
        for (let j = 0; j < propertyNames.length; j++) {
          if (typeof keyNames[j] !== "undefined") {
            td1 = document.createElement("td");
            div = document.createElement("div");
            div.setAttribute("class", "text-center1");
            tdText1 = document.createTextNode(list[keyNames[j].keyName]);
            div.appendChild(tdText1);
            td1.appendChild(div);
            tr1.appendChild(td1);
          }
        }
        tbody.appendChild(tr1);
      }
    } else {
    }
  }

  getRoleId() {
    const userData = JSON.parse(localStorage.getItem("userData"));

    return userData.role;
  }

  getNameRegEx() {
    const orgRegEx = /^\b[A-Za-z0-9-,/&_() ]+$/;
    return orgRegEx;
  }

  getNameRegWithDotEx() {
    const orgRegEx = /^\b[A-Za-z0-9-.,/&_() ]+$/;
    return orgRegEx;
  }

  getApplicationIdRegEx() {
    const applicationIdRegEx = /^\b[0-9,/]+$/;
    return applicationIdRegEx;
  }

  getCodeRegEx() {
    const orgRegEx = /^\b[A-Za-z0-9-/,&_ ]+$/;
    return orgRegEx;
  }

  getCategoryInputRegx() {
    const catRegEx = /^\b[A-Za-z0-9,&_ -]+$/;
    return catRegEx;
  }
  getEmailRegEx() {
    const emailRegEx = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
    return emailRegEx;
  }

  getPanRegEx() {
    const panRegEx = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegEx;
  }

  getGstRegEx() {
    const gstRegEx =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegEx;
  }

  getContactRegEx() {
    const contactRegex = /^\s*-?[0-9]{10,10}\s*$/;
    return contactRegex;
  }

  getNumberRegEx() {
    const numberRegex = /^\d+$/;
    return numberRegex;
  }

  getPhoneRegEx() {
    const phoneRegEx = /^\+?[0-9]{10}$/;
    return phoneRegEx;
  }

  // getAwsCreds() {
  //   const env = this.getProdOrDevUrl();
  //   const awsKeys = {
  //     secretKey: env
  //       ? environmentProd.key.awsCreds.secretKey
  //       : environment.key.awsCreds.secretKey,
  //     accessKey: env
  //       ? environmentProd.key.awsCreds.accessKey
  //       : environment.key.awsCreds.accessKey,
  //     region: env
  //       ? environmentProd.key.awsCreds.region
  //       : environment.key.awsCreds.region,
  //     url: env
  //       ? environmentProd.key.awsCreds.url
  //       : environment.key.awsCreds.url,
  //     bucket: env
  //       ? environmentProd.key.awsCreds.bucket
  //       : environment.key.awsCreds.bucket,
  //     bucket2: env
  //       ? environmentProd.key.awsCreds.bucket2
  //       : environment.key.awsCreds.bucket2,
  //     expire: env
  //       ? environmentProd.key.awsCreds.expiresIn
  //       : environment.key.awsCreds.expiresIn,
  //   };
  //   return awsKeys;
  // }

  async downloadFromAws(filePath: string, filename?): Promise<string> {
    // if (filePath.includes("https")) {
    //   return filePath;
    // }
    // const getCreds = this.getAwsCreds();
    // let client = new S3Client({
    //   region: getCreds.region,
    //   credentials: {
    //     accessKeyId: getCreds.accessKey,
    //     secretAccessKey: getCreds.secretKey,
    //   },
    // });
    // let path = filePath.split(`${getCreds.bucket}/`);
    // let firstPath: boolean = true;
    // if (path.length === 1) {
    //   path = filePath.split(`${getCreds.bucket2}/`);
    //   firstPath = false;
    // }
    // let getCommand: any;
    // if (filename) {
    //   getCommand = new GetObjectCommand({
    //     Bucket: firstPath ? getCreds.bucket : getCreds.bucket2,
    //     Key: path[1],
    //     ResponseContentDisposition: `attachment; filename="${filename}"`,
    //   });
    // } else {
    //   getCommand = new GetObjectCommand({
    //     Bucket: firstPath ? getCreds.bucket : getCreds.bucket2,
    //     Key: path[1],
    //   });
    // }

    // const signedUrl = await getSignedUrl(client, getCommand, {
    //   expiresIn: getCreds.expire,
    //   signingRegion: getCreds.region,
    // });
    return new Promise((resolve: any, reject: any) => {
      if (filePath) {
        if (filePath.includes("https")) {
          resolve(filePath);
        } else {
          resolve("Wrong URL provided!");
        }
      }
      if (filename) {
        if (filename.includes("https")) {
          resolve(filename);
        } else {
          resolve("Wrong URL provided!");
        }
      }
      // if (filePath) {
      //   resolve(filePath);
      // }
      // if (filename) {
      //   resolve(filename);
      // }
      resolve("File name or File path no found !");
    });
  }

  async downloadAwsObject(filePath: string, fileName: string) {
    // const getCreds = this.getAwsCreds();
    // let client = new S3Client({
    //   region: getCreds.region,
    //   credentials: {
    //     accessKeyId: getCreds.accessKey,
    //     secretAccessKey: getCreds.secretKey,
    //   },
    // });
    // let path = filePath.split(`${getCreds.bucket}/`);
    // let firstPath: boolean = true;
    // if (path.length === 1) {
    //   path = filePath.split(`${getCreds.bucket2}/`);
    //   firstPath = false;
    // }
    // const getCommand = new GetObjectCommand({
    //   Bucket: firstPath ? getCreds.bucket : getCreds.bucket2,
    //   Key: path[1],
    // });
    // const response = await client.send(getCommand);
    // const str = await response.Body.transformToByteArray();
    let signedUrl = "";
    if (filePath) {
      if (filePath.includes("https")) {
        signedUrl = filePath;
      }
    }
    if (fileName) {
      if (fileName.includes("https")) {
        signedUrl = fileName;
      }
    }
    if (signedUrl != "") {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("target", "_blank");
      a.href = signedUrl;
      a.download = fileName;
      a.click();
      a.remove();
      return "Success";
    } else {
      return "Failed";
    }
  }

  // async downloadAwsObjectForHtmlFile(filePath: string) {
  //   const getCreds = this.getAwsCreds();
  //   let client = new S3Client({
  //     region: getCreds.region,
  //     credentials: {
  //       accessKeyId: getCreds.accessKey,
  //       secretAccessKey: getCreds.secretKey,
  //     },
  //   });
  //   let path = filePath.split(`${getCreds.bucket}/`); // use bucket 3 instead
  //   const getCommand = new GetObjectCommand({
  //     Bucket: getCreds.bucket,
  //     Key: path[1],
  //   });
  //   const response = await client.send(getCommand);
  //   return response;
  // }

  formatTime(date) {
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  }

  getWorkAreaAndStoreId() {
    const storageData = localStorage.getItem("userData");
    const getWorkAreaId = JSON.parse(storageData);
    const storeId = getWorkAreaId.storeId;
    const workAreaId = getWorkAreaId.workAreaIds[0];
    const roleId = getWorkAreaId.role;

    return {
      storeId,
      workAreaId,
      roleId,
    };
  }

  getPageDimensions(): { height: number; width: number; percentage: number } {
    const pageheight = window.innerHeight;
    const cutOff = pageheight - 120;
    const percentage = (100 * cutOff) / pageheight;
    const height = Math.round(percentage);
    const calculateTwoThirdsHeight = Math.round(cutOff * (2 / 3));
    const calculateOneThirdHeight = Math.round(cutOff * (1 / 3));
    const windowWidth = window.screen.width * window.devicePixelRatio;
    const windowHeight = window.screen.height * window.devicePixelRatio;
    const screenWidthResolution = Math.floor(windowWidth);
    const screenHeightResolution = Math.floor(windowHeight);

    const pagedimension = {
      height: window.innerHeight,
      width: window.innerWidth,
      percentage: height,
      cutOff,
      calculateTwoThirdsHeight,
      calculateOneThirdHeight,
      screenHeightResolution,
      screenWidthResolution,
    };
    ////console.log('pagedimension : ', pagedimension);
    return pagedimension;
  }

  /* calculateTwoThirdsHeight(screenHeight: number): number {
    const calculateTwoThirdsHeight = Math.round(screenHeight * (2 / 3));
    return calculateTwoThirdsHeight - 50;
  }

  calculateOneThirdHeight(screenHeight: number): number {
    const calculateOneThirdHeight = Math.round(screenHeight * (1 / 3));
    return calculateOneThirdHeight - 50;
  } */

  getScreenScale() {
    const devicePixelRatio = window.devicePixelRatio;
    let ratio;
    if (devicePixelRatio === 1) {
      ratio = 1;
    } else if (devicePixelRatio > 1) {
      ratio = 2;
    } else {
      ratio = 0; // handle other scale values if needed
    }
    return ratio;
  }

  resolutionWiseFont() {
    const windowWidth = window.screen.width * window.devicePixelRatio;
    let chartTitle, chartSubTitle;
    if (windowWidth > 1920) {
      if (window.devicePixelRatio <= 1) {
        chartTitle = 12;
        chartSubTitle = 10;
      } else {
        chartTitle = 11;
        chartSubTitle = 9;
      }
    } else if (windowWidth >= 1600 && windowWidth <= 1920) {
      if (window.devicePixelRatio <= 1) {
        chartTitle = 12;
        chartSubTitle = 10;
      } else {
        chartTitle = 11;
        chartSubTitle = 9;
      }
    } else if (windowWidth >= 1400 && windowWidth < 1600) {
      if (window.devicePixelRatio <= 1) {
        chartTitle = 11;
        chartSubTitle = 9;
      } else {
        chartTitle = 9;
        chartSubTitle = 7;
      }
    } else if (windowWidth >= 1200 && windowWidth < 1400) {
      if (window.devicePixelRatio <= 1) {
        chartTitle = 9;
        chartSubTitle = 7;
      } else {
        chartTitle = 7;
        chartSubTitle = 5;
      }
    }
    return {
      chartTitle,
      chartSubTitle,
    };
  }

  /* Deep Copy */
  updateArray(
    mainArr: any,
    mainIndex: number,
    subIndex: number,
    errorMsg: string,
    isError: boolean,
  ) {
    //const array = mainArr;
    let array = mainArr;
    let updatedArray = this.updateArrayObject(array, mainIndex, subIndex, {
      error: { isError: isError, errorMsg: errorMsg },
    });
    return updatedArray;
  }

  updateArrayObject(array, rowIndex, objectIndex, newProperties) {
    let newArray = this.deepCopyArray(array);
    let targetObject = newArray[rowIndex][objectIndex];
    Object.assign(targetObject, newProperties);
    return newArray;
  }

  deepCopyArray(arr) {
    return arr.map((obj) => this.deepCopy(obj));
  }

  deepCopy(obj) {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }

    let newObj = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
      newObj[key] = this.deepCopy(obj[key]);
    }
    return newObj;
  }
  /* Deep Copy */

  updateObject(openAuctionJson: any, propertyName: any, filterDataList: any) {
    const keyNames = Object.keys(propertyName);
    keyNames.map((keys: any) => {
      openAuctionJson[keys] = filterDataList[keys];
    });
    return openAuctionJson;
  }

  setStoreLogin(store: any, countryName: any) {
    console.log(store);

    this.storeId = store;
    this.countryName = countryName;
    localStorage.setItem("storeId", store);
    localStorage.setItem("countryName", countryName);
  }

  getStoreLogin() {
    return this.storeId
      ? this.storeId
      : Number(localStorage.getItem("storeId"));
    // return this.storeId?this.storeId:Number(localStorage.getItem('storeId')?localStorage.getItem('storeId'):100);
  }

  getCountryName() {
    return this.countryName
      ? this.countryName
      : localStorage.getItem("countryName");
    // return this.countryName;
  }

  sendToHome() {
    this.extractStorageData()
      .then((data: any) => {
        this.router.navigate(["post-auth/home"]);
      })
      .catch(() => {
        this.router.navigate(["pre-auth/login"]);
      });
  }

  signOutUser() {
    const originUrl = JSON.parse(localStorage.getItem("userData")).originUrl;
    // console.log(originUrl);
    this.router.navigateByUrl(originUrl);
    localStorage.clear();
    // if (isObserver !== null && isObserver === '1') {
    //   storeId === 100 ? this.router.navigate(['pre-auth/login']) : this.router.navigate([`pre-auth/${countryStore[storeId]}/login`]);
    // } else if (isObserver !== null && isObserver !== '1') {
    //   this.router.navigate(['pre-auth/login']);
    // }
    // if (isObserver !== null && isObserver === '1') {
    //   if (observerType && observerType?.toLowerCase() === countryStore[storeId]) {
    //     this.router.navigate([`pre-auth/${countryStore[storeId]}/observer/observer-login`])

    //   } else {
    //     this.router.navigate(['pre-auth/observer/observer-login'])
    //   }
    //   this.setStoreLogin(storeId);
    // } else if (isObserver !== null && isObserver !== '1') {
    //   if (adminType && adminType?.toLowerCase() === countryStore[storeId]) {
    //     this.router.navigate([`pre-auth/${countryStore[storeId]}/login`])

    //   } else {
    //     this.router.navigateByUrl('pre-auth/login');
    //   }
    //   this.setStoreLogin(storeId);
    // }
  }

  reportPath(value: any, type: any) {
    const prod = this.getProdOrDevUrl();
    let path = prod
      ? environmentProd.report_base_url + value.filepath + "." + type
      : environment.report_base_url + value.filepath + "." + type;
    return path;
  }

  getApiVersion(url: string) {
    if (url[url.length - 1] == "/") {
      return Number(url[url.length - 2]);
    }
    return Number(url[url.length - 1]);
  }

  async getAppVersion() {
    const env = this.getProdOrDevUrl();
    const app = {
      version: env ? environmentProd.version : environment.version,
    };
    return app;
  }

  //For copy to clipboard
  copyToClipboard(text: string): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData?.setData("text/plain", text);
      e.preventDefault();
    };

    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);

    this.toastService.showSuccessToast("message", "Copied to clipboard");
  }

  getAllCurrencyList() {
    const currencyList = [
      {
        id: 100,
        localeCode: "en-IN",
        currencyOptions: {
          name: "Rupee",
          plural: "Rupees",
          symbol: "₹",
          fractionalUnit: {
            name: "Paisa",
            plural: "Paise",
            symbol: "",
          },
        },
      },
      {
        id: 101,
        localeCode: "en-US",
        currencyOptions: {
          name: "Dollar",
          plural: "Dollar",
          symbol: "$",
          fractionalUnit: {
            name: "cent",
            plural: "cents",
            symbol: "",
          },
        },
      },
      {
        id: 102,
        localeCode: "en-GB",
        currencyOptions: {
          name: "Pound",
          plural: "Pounds",
          symbol: "£",
          fractionalUnit: {
            name: "Penny",
            plural: "Pence",
            symbol: "",
          },
        },
      },
      {
        id: 103,
        localeCode: "en-GB",
        currencyOptions: {
          name: "Euro",
          plural: "Euro",
          symbol: "€",
          fractionalUnit: {
            name: "",
            plural: "",
            symbol: "",
          },
        },
      },
      {
        id: 104,
        localeCode: "en-AE",
        currencyOptions: {
          name: "AED",
          plural: "AED",
          symbol: "AED",
          fractionalUnit: {
            name: "",
            plural: "",
            symbol: "",
          },
        },
      },
      {
        id: 105,
        localeCode: "en-US",
        currencyOptions: {
          name: "NA",
          plural: "NA",
          symbol: "NA",
          fractionalUnit: {
            name: "",
            plural: "",
            symbol: "",
          },
        },
      },
      {
        id: 106,
        localeCode: "en-US",
        currencyOptions: {
          name: "PERCENTAGE PREMIUM",
          plural: "PERCENTAGE PREMIUMS",
          symbol: "",
          fractionalUnit: {
            name: "",
            plural: "",
            symbol: "",
          },
        },
      },
      {
        id: 107,
        localeCode: "en-US",
        currencyOptions: {
          name: "OMR",
          plural: "OMRS",
          symbol: "",
          fractionalUnit: {
            name: "",
            plural: "",
            symbol: "",
          },
        },
      },
      {
        id: 109,
        localeCode: "id-ID",
        currencyOptions: {
          name: "Rupiah",
          plural: "Rupiah",
          symbol: "Rp",
          fractionalUnit: {
            name: "Sen",
            plural: "Sen",
            symbol: "",
          },
        },
      },
      {
        id: 111,
        localeCode: "ar-SA",
        currencyOptions: {
          name: "Saudi Riyal",
          plural: "Saudi Riyals",
          symbol: "SAR",
          fractionalUnit: {
            name: "Halala",
            plural: "Halalas",
            symbol: "",
          },
        },
      }
    ];

    return currencyList;
  }

  getCurrencyByCode(id) {
    return this.getAllCurrencyList().find((data) => {
      return data.id == id;
    });
  }

  reportEncDataCreate(params: any) {
    const _srcs = CryptoJS.enc.Utf8.parse(params);
    const _encryptedText = CryptoJS.AES.encrypt(_srcs, this._key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();
    return { encVal: _encryptedText };
  }
  setServerTime(time: Date) {
    this.setServer.next(time);
  }

  getStoreObject(url): {
    storeId: number;
    countryName: string;
    flag: string;
  } {
    const storeObject = {
      uae: {
        storeId: 115,
        countryName: "UAE",
        flag: "GST"
      },
      uk: {
        storeId: 118,
        countryName: "UK",
        flag: "GMT"
      },
      rakpsd: {
        storeId: 112,
        countryName: "RAKPSD",
        flag: "GST"
      },
      spices: {
        storeId: 114,
        countryName: "SPICES",
        flag: "IST"
      },
      acc: {
        storeId: 119,
        countryName: "ACC",
        flag: "IST"
      },
      flyash: {
        storeId: 120,
        countryName: "FLYASH",
        flag: "IST"
      },
      cab: {
        storeId: 100,
        countryName: "CAB",
        flag: "IST"
      },
      agro: {
        storeId: 113,
        countryName: "AGRO",
        flag: "IST"
      },
      cgmarkfed: {
        storeId: 121,
        countryName: "CGMARKFED",
        flag: "IST"
      },
      m2: {
        storeId: 122,
        countryName: "MJPlus",
        flag: "IST"
      },
      ico: {
        storeId: 123,
        countryName: "ICO",
        flag: "IST"
      },
      chipsmine: {
        storeId: 106,
        countryName: "CHIPS MINE",
        flag: "IST"
      },
      fci: {
        storeId: 103,
        countryName: "FCI",
        flag: "IST"
      },
      jindal: {
        storeId: 124,
        countryName: "JINDAL REALTY",
        flag: "IST"
      },
    };

    return storeObject[url];
  }

  async streamToBuffer(readableStream) {
    const reader = readableStream.getReader();
    const chunks = [];
    let done, value;

    while (true) {
      ({ done, value } = await reader.read());
      if (done) break;
      chunks.push(value);
    }

    return new Blob(chunks); // You can return Buffer.from(...) if you still need a Buffer
  }

  // Download and convert to Blob
  // async downloadFileAsBlob(filePath: string) {
  //   const getCreds = this.getAwsCreds();
  //   let client = new S3Client({
  //     region: getCreds.region,
  //     credentials: {
  //       accessKeyId: getCreds.accessKey,
  //       secretAccessKey: getCreds.secretKey,
  //     },
  //   });
  //   // let mainPath = filePath.split("?")[0].split('.com')[1];
  //   // debugger
  //   let path = filePath.split(`${getCreds.bucket}/`);
  //   let firstPath: boolean = true;
  //   if (path.length === 1) {
  //     path = filePath.split(`${getCreds.bucket2}/`);
  //     firstPath = false;
  //   }
  //   // console.log(firstPath,path[1],filePath);
  //   const command = new GetObjectCommand({
  //     Bucket: firstPath ? getCreds.bucket : getCreds.bucket2,
  //     Key: path[1],
  //   });

  //   try {
  //     const response = await client.send(command);
  //     const buffer = await this.streamToBuffer(response.Body);
  //     const blob = new Blob([buffer]);

  //     // console.log('Blob created:', blob);
  //     return blob;
  //   } catch (error) {
  //     console.error("Error downloading file from S3:", error);
  //     return null;
  //   }
  // }

  modifyDashboardUrl(menuList) {
    let dashboardUrl = [];

    menuList.map((mainMenu) => {
      if (mainMenu.menu == undefined && mainMenu.actionDetail != 'Home') {
        return mainMenu;
      } else if (mainMenu.menu == undefined && mainMenu.actionDetail == 'Home') {
        let path = structuredClone(mainMenu.actionURL.split("~"));
        if (path.length > 1) {
          dashboardUrl.push({
            url: path[0],
            reportName: path[1],
            pythonUrl: path[2],
          });
        }
      } else if (Array.isArray(mainMenu.menu)) {
        mainMenu.menu.map((subMenu) => {
          let path = subMenu.actionURL.split("~");
          if (path.length > 1) {
            dashboardUrl.push({
              url: path[0],
              reportName: path[1],
              pythonUrl: path[2],
            });

            subMenu.actionURL = path[0];
            return subMenu;
          }
        });
      }
      return mainMenu;
    });
    console.log();

    localStorage.setItem("analyticsPath", JSON.stringify(dashboardUrl));
    return menuList;
  }

  getHeaderPreLogin(params: any, version: any) {
    if (params === "") {
      this.headers = new HttpHeaders({
        apiversion: version,
      });
    } else {
      const _srcs = CryptoJS.enc.Utf8.parse(params);
      const _encryptedText = CryptoJS.AES.encrypt(_srcs, this._key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
      this.headers = new HttpHeaders({
        apiversion: version,
        encVal: _encryptedText,
      }).set("ngsw-bypass", "");
    }
    return { headers: this.headers };
  }


  // setExternalObj(urls) {
  //   this.externalObjSubject.next(urls);
  // }

  setRakutenData (val) {
    this.rakutenData = new RakutenData(
      val?.RAKUTEN_AUTH ? val?.RAKUTEN_AUTH : '',
      val?.RAKUTEN_SERVICE_NAME ? val?.RAKUTEN_SERVICE_NAME : '',
      val?.RAKUTEN_COLLECTOR ? val?.RAKUTEN_COLLECTOR : '',
      val?.RAKUTEN_SERVICE_VERSION ? val?.RAKUTEN_SERVICE_VERSION : '',
    );
  }

  getRakutenData() {
    return this.rakutenData;
  }

  setAgroData(val) {
    this.agroData = new AgroData(
      val?.RECAPTCHA_V2_KEY ? val?.RECAPTCHA_V2_KEY : '',
      val?.RECAPTCHA_V3_KEY ? val?.RECAPTCHA_V3_KEY : '',
      val?.metalAnalyticsBaseUrl ? val?.metalAnalyticsBaseUrl : '',
      val?.rakAnalyticsBaseUrl ? val?.rakAnalyticsBaseUrl : '',
    );
  }

  getAgroData() {
    return this.agroData;
  }

  setCommonStoreData (val) {
    this.commonStoreData = new CommonStoreData(
      val?.pythonApi ? val?.pythonApi : ''
    )
  }

  getCommonStoreData() {
    return this.commonStoreData;
  }
  downloadFile(url){
    return this.http.get(url, { responseType: 'blob' });
  }
}
